import type { FilterFieldsStylingContextProviderProps } from './FilterFieldsStylingContext.types'
import { FilterFieldsStylingContext } from './FilterFieldsStylingContext'

export const FilterFieldsStylingContextProvider = ({
  value,
  children
}: FilterFieldsStylingContextProviderProps) => {
  return (
    <FilterFieldsStylingContext.Provider value={value}>
      {children}
    </FilterFieldsStylingContext.Provider>
  )
}
